// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-components-details-template-js": () => import("./../src/components/details-template.js" /* webpackChunkName: "component---src-components-details-template-js" */),
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-introduction-js": () => import("./../src/pages/introduction.js" /* webpackChunkName: "component---src-pages-introduction-js" */)
}

